import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "drama-card"
};
const _hoisted_2 = {
  key: 0,
  class: "gradient-border-box"
};
const _hoisted_3 = {
  class: "image-wrapper"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "drama-basic-info"
};
const _hoisted_6 = {
  class: "dramaName"
};
const _hoisted_7 = {
  class: "dramaDetailInfo"
};
const _hoisted_8 = {
  class: "row"
};
const _hoisted_9 = {
  class: "row"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = ["innerHTML"];
import { ElTimeline } from 'element-plus';
import { getDifficultyDegree } from '@/tools/utils';
export default {
  __name: 'DramaPerformance',
  props: {
    dataArray: {
      type: Array,
      required: true
    },
    roleId: {
      type: [String, Number],
      default: null,
      required: false
    }
  },

  setup(__props) {
    const props = __props;

    const getCastDesc = item => {
      let castArray = item?.cast ?? [];
      if (!props.roleId) return castArray.map(item => item.nickname).join('、');
      let buffer = castArray.filter(role => role.id.toString() !== props.roleId.toString()).map(role => {
        if (role['mvp']) {
          return `<strong style="
                                /*font-size: 40px; !* 字体大小可调整 *!*/
                                font-weight: bold; /* 字体加粗效果 */
                                background: linear-gradient(to bottom right, #FF7F50, #ffd299);
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent; /* 需要前缀以支持 Safari 和旧版 Chrome */
                                text-fill-color: transparent;
                                display: inline-block;
                              ">
                        ${role.nickname}(卓越)
                      </strong>`;
        }

        return role.nickname;
      });
      return buffer.join('、');
    };

    const isMVP = item => {
      if (!props.roleId) return false;
      let castArray = item?.cast ?? [];
      let buffer = castArray.filter(role => role['id'].toString() === props.roleId.toString());
      if (buffer.length === 0) return false;
      return buffer[0]['mvp'];
    };

    return (_ctx, _cache) => {
      const _component_el_timeline_item = _resolveComponent("el-timeline-item");

      return _openBlock(), _createBlock(_unref(ElTimeline), null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataArray, (item, index) => {
          return _openBlock(), _createBlock(_component_el_timeline_item, {
            key: index,
            hollow: true,
            timestamp: item.end_date,
            class: "resumeItem",
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[7] || (_cache[7] = _createElementVNode("div", {
              class: "performance-back"
            }, null, -1)), isMVP(item) ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
              src: item.drama.image_url,
              alt: "",
              class: _normalizeClass(["faded-image", isMVP(item) ? 'faded-image-mvp' : '']),
              draggable: "false"
            }, null, 10, _hoisted_4), _cache[0] || (_cache[0] = _createElementVNode("div", {
              class: "mask-layer"
            }, null, -1))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("text", _hoisted_6, _toDisplayString(item.drama.name), 1), _createElementVNode("text", null, _toDisplayString(item.drama.world_outlook.nature) + "世界观 - " + _toDisplayString(item.drama.world_outlook.name), 1), _createElementVNode("text", null, "来自：" + _toDisplayString(item.drama.creator_org ? `${item.drama.creator_org} - ${item.drama.creator}` : item.drama.creator), 1), _createElementVNode("text", null, "预计时长：" + _toDisplayString(item.drama.construction_period), 1), _createElementVNode("text", null, "游玩时长：" + _toDisplayString(item.duration) + "h", 1), _createElementVNode("text", null, "剧情完成度：" + _toDisplayString(item.completeness) + "%", 1), _createElementVNode("text", null, "剧情破解度：" + _toDisplayString(item.solving_rate) + "%", 1)]), _cache[8] || (_cache[8] = _createElementVNode("div", {
              class: "divider"
            }, null, -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("text", null, _toDisplayString(_unref(getDifficultyDegree)(item.drama.difficulty)) + " / " + _toDisplayString(item.drama.nature.desc) + " （" + _toDisplayString((item.drama.difficulty / 10).toFixed(1)) + "/10.0） " + _toDisplayString(item.drama.tendency === '' ? '' : '（' + item.drama.tendency + '）'), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("text", null, [_cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)), _cache[2] || (_cache[2] = _createTextVNode(" 链接者：", -1)), _createElementVNode("span", {
              innerHTML: item.anchor.name
            }, null, 8, _hoisted_10), _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(__props.roleId ? '同行者' : '选中者') + "：", 1), _createElementVNode("span", {
              innerHTML: getCastDesc(item)
            }, null, 8, _hoisted_11), _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(item.start_date) + "始，" + _toDisplayString(item.end_date) + "止，历时 " + _toDisplayString(item.duration) + "h 结束模组 ", 1), _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)), _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(item.summary), 1)])])]), _cache[9] || (_cache[9] = _createElementVNode("div", {
              style: {
                "display": "flex",
                "flex": "1"
              }
            }, null, -1))])]),
            _: 2
          }, 1032, ["timestamp"]);
        }), 128))]),
        _: 1
      });
    };
  }

};